import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import CustomDialog from "../../custom/custom-dialog.vue";

@Component({
    components: {
        CustomDialog,
    },
})
export default class NcEditDialog extends Vue {
    isNonConformity: boolean = false;
    nonConformityComment: string = "";

    get showDialogNc(): boolean {
        return this.$store.direct.state.supervisor.showNcEditDialog;
    }

    set showDialogNc(value: boolean) {
        this.$store.direct.commit.supervisor.setShowNcEditDialog(value);
    }

    initializeData() {
        this.isNonConformity = this.$store.direct.state.supervisor.supervisor.isNonConformity;
        this.nonConformityComment = this.$store.direct.state.supervisor.supervisor.nonConformityComment;
    }

    @Watch('showDialogNc')
    onShowDialogNcChange(val: boolean) {
        if (val)
            this.initializeData();
        else
            this.clearData();
    }

    clearData() {
        this.isNonConformity = false;
        this.nonConformityComment = "";
    }

    async cancelClick() {
        this.$store.direct.commit.supervisor.setShowNcEditDialog(false);
        await this.$store.direct.dispatch.supervisor.loadSupervisor({ id: this.$store.direct.state.supervisor.supervisor.id });
    }

    async save() {
        await this.$store.direct.dispatch.supervisor.saveNonConformity({
            supervisorId: this.$store.direct.state.supervisor.supervisor.id,
            isNonConformity: this.isNonConformity,
            nonConformityComment: this.nonConformityComment,
        });
        this.$store.direct.commit.supervisor.setShowNcEditDialog(false);
        await this.$store.direct.dispatch.supervisor.loadSupervisor({ id: this.$store.direct.state.supervisor.supervisor.id });
    }
}
